<template>
  
  <page-container
    :mobile-image="content.heroImage.mobile"
    :default-position="content.heroImageOptions.default.customPosition[0] ? content.heroImageOptions.default.customPosition[1] : 'center'"
    :mobile-position="content.heroImageOptions.mobile.customPosition[0] ? content.heroImageOptions.mobile.customPosition[1] : 'center'"
    :mobile-size="content.heroImageOptions.mobile.customSize ? content.heroImageOptions.mobile.customSize : 'cover'"
    class="page" 
  >
    
    <iframe v-if="content.floodlight" :src="floodlightUrl" width="1" height="1" frameborder="0" style="display:none"></iframe>

    <div
      :style="'background-image: url('+heroImage+')'"
      :class="{ 'page__background': true, 'page__background--preload' : heroImageBlur, 'overlay-default': true }"
    ></div>

    <section class="page__intro">

      <div class="wrapper">

        <div>

          <div class="wrapper__inner--intro">

            <h1 v-html="content.title">{{ content.title }}</h1>

            <ul class="dotnav">
              <li 
                v-for="(item, index) in allContent" 
                v-if="index > 0 && (index + 1) < allContent.length"
                :class="{ active: item == content }"
                :key="index" 
                @click="closeReadingAndNavigateToPage('page/'+(index+1)+'/index.html')"
              ></li>
            </ul>

            <section class="mobile__view-more">
              <button
                :class="{ 'read-more': true, 'read-more--open': pageOpen }" 
                @click="readContent();"
                v-html="buttonText"
              ></button>
            </section>

          </div>

        </div>

      </div>

      <!-- <div class="overlay__default"><span></span><span></span></div> -->

    </section>
    <img v-images-loaded:on.done="heroImageLoaded" :src="content.heroImage.loaded" class="hero-preload">


    <div id="navbar" class="page__navigation">

      <div class="wrapper">

        <div>

          <div class="wrapper__inner">

            <div class="navigation__links">

              <div>
                <span class="oicon-arrow-left nav" @click="navigateThroughPages(-1)"></span>
                <span class="oicon-arrow-right nav" @click="navigateThroughPages(1)"></span>
              </div>
              <div>
                <!-- <span :class="{ 'oicon-arrow-down': !pageOpen, 'oicon-arrow-up': pageOpen, 'flip': true }" @click="readContent();"></span> -->

                <button
                  :class="{ 'read-more': true, 'read-more--open': pageOpen }" 
                  @click="readContent();"
                  v-html="buttonText"
                ></button>
              </div>
              <div>
                <span class="icon-twitter" @click="shareContent('twitter', content.title)"></span>
                <span class="icon-facebook" @click="shareContent('facebook', '')"></span>
                <span class="icon-linkedin" @click="shareContent('linkedin', content.title)"></span>                
              </div>

            </div>


          </div>

        </div>

      </div>

    </div>



    <section
      v-hammer:swipe.horizontal="swipeContent"
      id="content"
      class="page__content"
    >

      <div class="wrapper">

        <component 
          v-for="(section, index) in content.sections" 
          :is="section.component"
          :content="section.content"
          :key="index"
        ></component>


      </div>

      <section-next-page
        v-if="haveNextPage"
        :content="allContent[$route.params.pageid]"
      ></section-next-page>
   
      <section-footer css-class="default"></section-footer>

    </section>

    <div id="scriptHolder"></div>
  </page-container>
</template>

<script>

  // import our vuex state management
  import store from '@/store';
  import TweenLite from 'gsap';
  import imagesLoaded from 'vue-images-loaded'
  // eslint-disable-next-line
  import { $, $$ } from '../lib/bling';
  import styled from 'vue-styled-components';

  // section content blocks
  import SectionCopy from '@/components/Blocks/SectionCopy.vue';
  import SectionSeperator from '@/components/Blocks/SectionSeperator.vue';
  import SectionQuote from '@/components/Blocks/SectionQuote.vue';
  import SectionImage from '@/components/Blocks/SectionImage.vue';
  import SectionAuthor from '@/components/Blocks/SectionAuthor.vue';
  import SectionCallToAction from '@/components/Blocks/SectionCallToAction.vue';
  import SectionNextPage from '@/components/Blocks/SectionNextPage.vue';
  import SectionFooter from '@/components/Blocks/SectionFooter.vue';
  import SectionReferences from '@/components/Blocks/SectionReferences.vue';

  // mixins
  import ShareContent from '@/mixins/shareContent';
  import NavigatePages from '@/mixins/navigatePages';
  import HeroImageLoaded from '@/mixins/heroImageLoaded';

  // create our styled componenets
  const pageProps = { 
    mobileImage: String, 
    defaultPosition: String,
    mobilePosition: String,
    mobileSize: String
  };

  const PageContainer = styled('section', pageProps)`
    
    @media (max-width: 991.98px) {
      background-image: url(${props => props.mobileImage});
      background-size: ${props => props.mobileSize};
      background-position: ${props => props.mobilePosition}
    }

    .page__background {
      background-position: ${props => props.defaultPosition}
    }

`;

  export default {
    name: 'PageTypeA',
    directives: {
      imagesLoaded
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    metaInfo() {
      return {
        title: this.content.meta.title,
        titleTemplate: `%s - Your Tomorrow, Today - Page ${this.$route.params.pageid}`,
        meta: [
          { name: 'description', content: this.content.meta.description },
          { property: 'og:type', content: this.content.meta.og.type },
          { property: 'og:title', content: this.content.meta.og.title },
          { property: 'og:description', content: this.content.meta.og.description },
          { property: 'og:image', content: this.content.meta.og.image },
          { name: 'twitter:card', content: this.content.meta.twitter.card },
          { name: 'twitter:title', content: this.content.meta.twitter.title },
          { name: 'twitter:description', content: this.content.meta.twitter.description },
          { name: 'twitter:site', content: this.content.meta.twitter.site },
          { name: 'twitter:creator', content: this.content.meta.twitter.creator },
          { name: 'twitter:image', content: this.content.meta.twitter.image }
        ]
      }
    },
    data() {
      return {
        pageOpen: false,
        allContent: store.getters.getAllPageContent,
        heroImage: this.content.heroImage.preload,
        heroImageBlur: true   
      }
    },
    computed: {
      pageCss() {
        return `page ${this.content.cssClass}`;
      },
      closeContent: () => store.getters.getCloseContent,

      buttonText() {
        return this.pageOpen ? 'Back to top' : 'Read more';
      },
      haveNextPage() {
        return this.allContent[this.$route.params.pageid] ? true : false
      },
      floodlightUrl() {
        if (!this.content.floodlight) {
          return null;
        }

        // from doubleclick...
        const axel = Math.random() + "";
        const a = axel * 10000000000000;
        return `${this.content.floodlight}num=${a}?`;
      

      }

    },
    components: {
      SectionCopy,
      SectionSeperator,
      SectionQuote,
      SectionImage,
      SectionAuthor,
      SectionCallToAction,
      SectionNextPage,
      SectionFooter,
      SectionReferences,
      PageContainer
    },
    mixins: [ ShareContent, NavigatePages, HeroImageLoaded ],
    watch: {

      closeContent() {

        if (this.closeContent && this.pageOpen) {

          this.closeContentPane();
          store.commit('setCloseContent', false);

        }

      }

    },
    methods: {

      swipeContent() {

        // this method forces the horizontal swipe to trigger when content block is open
        return;

      },

      pageStatusChange(status) {

        this.pageOpen = !this.pageOpen;
        store.commit('setReadingContent', status);

      },

      openContentPane() {

        // get headerbar height
        const dimensions = $('#header').getBoundingClientRect();      
        // eslint-disable-next-line
        TweenLite.to('#content', 0.5, { css: { top: dimensions.height }, ease: Power2.easeOut });
        this.pageStatusChange(true);

      },

      closeContentPane() {
          
        // scroll the div to the top
        $('#content').scrollTop = 0;
        // eslint-disable-next-line
        TweenLite.to('#content', 0.5, { css: { top: '100vh' }, ease: Power2.easeOut });
        this.pageStatusChange(false);          


      },

      readContent() {

        if (!this.pageOpen) {          
          this.openContentPane();
        } else {
          this.closeContentPane();
        }

      }

    },
    mounted() {

      // animate the navbar into view
      // eslint-disable-next-line
      TweenLite.to('#navbar', 0.5, { y: 0, delay: 0.5, ease: Power2.easeOut });
      
    }

  };
</script>